
// import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { Snackbar, Alert } from "@mui/material";
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import MDInput from "components/MDInput";
// import MDButton from "components/MDButton";
// import BasicLayout from "layouts/authentication/components/BasicLayout";
// import bgImage from "assets/images/bg-sign-in-basic.jpeg";
// import { Card } from "@mui/material";

// function Basic() {
//   const [identifier, setIdentifier] = useState("");
//   const [password, setPassword] = useState("");
//   const [errorIdentifier, setErrorIdentifier] = useState("");
//   const [errorPassword, setErrorPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });

//   const navigate = useNavigate();

//   const validateEmail = (email) => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return emailRegex.test(email);
//   };

//   const handleSnackbarClose = () => {
//     setSnackbar({ open: false, message: "", severity: "info" });
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();

//     setLoading(true);
//     setErrorIdentifier("");
//     setErrorPassword("");
//     setSnackbar({ open: false, message: "", severity: "info" });

//     if (!identifier.trim()) {
//       setErrorIdentifier("Email ID cannot be empty.");
//       setLoading(false);
//       return;
//     }
//     if (!validateEmail(identifier)) {
//       setErrorIdentifier("Please enter a valid email address.");
//       setLoading(false);
//       return;
//     }
//     if (!password.trim()) {
//       setErrorPassword("Password cannot be empty.");
//       setLoading(false);
//       return;
//     }

//     try {
//       const loginResponse = await axios.post("https://api.exampladmedia.com/auth/login", {
//         identifier,
//         password,
//       });

//       const accessToken = loginResponse.data.token;
//       if (!accessToken) {
//         throw new Error("Login failed, no access token received.");
//       }

//       localStorage.setItem("accessToken", accessToken);
//       setSnackbar({ open: true, message: "Login successful!", severity: "success" });

//       const authResponse = await axios.post("https://api.exampladmedia.com/auth/authenticate", {
//         accessCode: accessToken,
//       });

//       const sessionToken = authResponse.data.sessionToken;
//       const userRole = authResponse.data.userRole;

//       if (!sessionToken) {
//         throw new Error("Authentication failed.");
//       }

//       localStorage.setItem("sessionToken", sessionToken);
//       localStorage.setItem("userRole", userRole);
//       setSnackbar({ open: true, message: "Authentication successful.", severity: "success" });

//       navigate("/Tables");
//     } catch (error) {
//       let errorMessage = "Something went wrong!";
//       if (error.response?.status === 401 || error.response?.status === 403) {
//         errorMessage = "Invalid credentials.";
//       }
//       setSnackbar({ open: true, message: errorMessage, severity: "error" });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <BasicLayout>
//       <Snackbar
//   open={snackbar.open}
//   autoHideDuration={6000}
//   onClose={handleSnackbarClose}
//   anchorOrigin={{ vertical: "top", horizontal: "center" }}
// >
//   <Alert
//     onClose={handleSnackbarClose}
//     severity={snackbar.severity}
//     sx={{ 
//       width: "100%", 
//       backgroundColor: snackbar.severity === "error" ? "#000" : undefined, 
//       color: snackbar.severity === "error" ? "#fff" : undefined 
//     }}
//   >
//     {snackbar.message}
//   </Alert>
// </Snackbar>

//       <Card>
//         <MDBox
//           variant="gradient"
//           bgColor="info"
//           borderRadius="lg"
//           coloredShadow="info"
//           mx={2}
//           mt={-3}
//           p={2}
//           mb={1}
//           textAlign="center"
//         >
//           <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
//             Sign in
//           </MDTypography>
//         </MDBox>
//         <MDBox pt={4} pb={3} px={3}>
//           <MDBox component="form" role="form" onSubmit={handleSubmit}>
//             <MDBox mb={2}>
//               <MDInput
//                 type="text"
//                 label="Email ID"
//                 fullWidth
//                 value={identifier}
//                 onChange={(e) => setIdentifier(e.target.value)}
//                 error={!!errorIdentifier}
//                 helperText={errorIdentifier}
//               />
//             </MDBox>
//             <MDBox mb={2}>
//               <MDInput
//                 type="password"
//                 label="Password"
//                 fullWidth
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 error={!!errorPassword}
//                 helperText={errorPassword}
//               />
//             </MDBox>
//             <MDBox mt={4} mb={1}>
//               <MDButton variant="gradient" color="info" fullWidth type="submit" disabled={loading}>
//                 {loading ? "Signing in..." : "Sign in"}
//               </MDButton>
//             </MDBox>
//           </MDBox>
//         </MDBox>
//       </Card>
//     </BasicLayout>
//   );
// }




// export default Basic;

























// import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { Snackbar, Alert } from "@mui/material";
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import MDInput from "components/MDInput";
// import MDButton from "components/MDButton";
// import BasicLayout from "layouts/authentication/components/BasicLayout";
// import bgImage from "assets/images/Weisenham.jpg";  
// import { Card } from "@mui/material";

// function Basic() {
//   const [identifier, setIdentifier] = useState("");
//   const [password, setPassword] = useState("");
//   const [errorIdentifier, setErrorIdentifier] = useState("");
//   const [errorPassword, setErrorPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });

//   const navigate = useNavigate();

//   const validateEmail = (email) => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return emailRegex.test(email);
//   };

//   const handleSnackbarClose = () => {
//     setSnackbar({ open: false, message: "", severity: "info" });
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();

//     setLoading(true);
//     setErrorIdentifier("");
//     setErrorPassword("");
//     setSnackbar({ open: false, message: "", severity: "info" });

//     if (!identifier.trim()) {
//       setErrorIdentifier("Email ID cannot be empty.");
//       setLoading(false);
//       return;
//     }
//     if (!validateEmail(identifier)) {
//       setErrorIdentifier("Please enter a valid email address.");
//       setLoading(false);
//       return;
//     }
//     if (!password.trim()) {
//       setErrorPassword("Password cannot be empty.");
//       setLoading(false);
//       return;
//     }

//     try {
//       const loginResponse = await axios.post("https://api.exampladmedia.com/auth/login", {
//         identifier,
//         password,
//       });

//       const accessToken = loginResponse.data.token;
//       if (!accessToken) {
//         throw new Error("Login failed, no access token received.");
//       }

//       localStorage.setItem("accessToken", accessToken);
//       setSnackbar({ open: true, message: "Login successful!", severity: "success" });

//       const authResponse = await axios.post("https://api.exampladmedia.com/auth/authenticate", {
//         accessCode: accessToken,
//       });

//       const sessionToken = authResponse.data.sessionToken;
//       const userRole = authResponse.data.userRole;

//       if (!sessionToken) {
//         throw new Error("Authentication failed.");
//       }

//       localStorage.setItem("sessionToken", sessionToken);
//       localStorage.setItem("userRole", userRole);
//       setSnackbar({ open: true, message: "Authentication successful.", severity: "success" });

//       navigate("/Tables");
//     } catch (error) {
//       let errorMessage = "Something went wrong!";
//       if (error.response?.status === 401 || error.response?.status === 403) {
//         errorMessage = "Invalid credentials.";
//       }
//       setSnackbar({ open: true, message: errorMessage, severity: "error" });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div

//       style={{
//         backgroundImage: `url(${bgImage})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center 20%", // Moves the image slightly downward
//         minHeight: "100vh",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}

//     >
//       <BasicLayout 

// >

//         <Snackbar
//           open={snackbar.open}
//           autoHideDuration={6000}
//           onClose={handleSnackbarClose}
//           anchorOrigin={{ vertical: "top", horizontal: "center" }}
//         >
//           <Alert
//             onClose={handleSnackbarClose}
//             severity={snackbar.severity}
//             sx={{ 
//               width: "100%", 
//               backgroundColor: snackbar.severity === "error" ? "#000" : undefined, 
//               color: snackbar.severity === "error" ? "#fff" : undefined 
//             }}
//           >
//             {snackbar.message}
//           </Alert>
//         </Snackbar>

//         <Card>
//           <MDBox
//             variant="gradient"
//             bgColor="info"
//             borderRadius="lg"
//             coloredShadow="info"
//             mx={2}
//             mt={-3}
//             p={2}
//             mb={1}
//             textAlign="center"
//           >
//             <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
//               Sign innn
//             </MDTypography>
//           </MDBox>
//           <MDBox pt={4} pb={3} px={3}>
//             <MDBox component="form" role="form" onSubmit={handleSubmit}>
//               <MDBox mb={2}>
//                 <MDInput
//                   type="text"
//                   label="Email ID"
//                   fullWidth
//                   value={identifier}
//                   onChange={(e) => setIdentifier(e.target.value)}
//                   error={!!errorIdentifier}
//                   helperText={errorIdentifier}
//                 />
//               </MDBox>
//               <MDBox mb={2}>
//                 <MDInput
//                   type="password"
//                   label="Password"
//                   fullWidth
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   error={!!errorPassword}
//                   helperText={errorPassword}
//                 />
//               </MDBox>
//               <MDBox mt={4} mb={1}>
//                 <MDButton variant="gradient" color="info" fullWidth type="submit" disabled={loading}>
//                   {loading ? "Signing in..." : "Sign in"}
//                 </MDButton>
//               </MDBox>
//             </MDBox>
//           </MDBox>
//         </Card>
//       </BasicLayout>
//     </div>
//   );
// }

// export default Basic;


// import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { Snackbar, Alert, InputAdornment, IconButton } from "@mui/material";
// import { Visibility, VisibilityOff } from "@mui/icons-material"; // Import icons
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import MDInput from "components/MDInput";
// import MDButton from "components/MDButton";
// import BasicLayout from "layouts/authentication/components/BasicLayout";
// import bgImage from "assets/images/banner.png";
// import { Card } from "@mui/material";
// import { usePublications } from "context/PublicationProvider";
// import SignUp from "../secondSignUp";

// function Basic() {
//   const { fetchOffers } = usePublications();
//   const [identifier, setIdentifier] = useState("");
//   const [password, setPassword] = useState("");
//   const [errorIdentifier, setErrorIdentifier] = useState("");
//   const [errorPassword, setErrorPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });
//   const [showPassword, setShowPassword] = useState(false); // State to manage password visibility
//   const [showSignUp, setShowSignUp] = useState(false);

//   const navigate = useNavigate();

//   const validateEmail = (email) => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return emailRegex.test(email);
//   };

//   const handleSnackbarClose = () => {
//     setSnackbar({ open: false, message: "", severity: "info" });
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     localStorage.setItem("popupShown", "false");
//     setLoading(true);
//     setErrorIdentifier("");
//     setErrorPassword("");
//     setSnackbar({ open: false, message: "", severity: "info" });

//     if (!identifier.trim()) {
//       setErrorIdentifier("Email ID cannot be empty.");
//       setLoading(false);
//       return;
//     }
//     if (!validateEmail(identifier)) {
//       setErrorIdentifier("Please enter a valid email address.");
//       setLoading(false);
//       return;
//     }
//     if (!password.trim()) {
//       setErrorPassword("Password cannot be empty.");
//       setLoading(false);
//       return;
//     }

//     try {
//       const loginResponse = await axios.post("https://api.exampladmedia.com/auth/login", {
//         identifier,
//         password,
//       });

//       const accessToken = loginResponse.data.token;
//       if (!accessToken) {
//         throw new Error("Login failed, no access token received.");
//       }

//       localStorage.setItem("accessToken", accessToken);
//       setSnackbar({ open: true, message: "Login successful!", severity: "success" });

//       const authResponse = await axios.post("https://api.exampladmedia.com/auth/authenticate", {
//         accessCode: accessToken,
//       });

//       const sessionToken = authResponse.data.sessionToken;
//       const userRole = authResponse.data.userRole;
//       const userId = authResponse.data.userId;
//       const name = authResponse.data.name;

//       if (!sessionToken) {
//         throw new Error("Authentication failed.");
//       }

//       localStorage.setItem("sessionToken", sessionToken);
//       localStorage.setItem("userRole", userRole);
//       localStorage.setItem("ueserId", userId);
//       localStorage.setItem("name", name);
//       setSnackbar({ open: true, message: "Authentication successful.", severity: "success" });
//       fetchOffers();
//       navigate("/Tables");
//     } catch (error) {
//       let errorMessage = "Something went wrong!";
//       if (error.response?.status === 401 || error.response?.status === 403) {
//         errorMessage = "Invalid credentials.";
//       }
//       setSnackbar({ open: true, message: errorMessage, severity: "error" });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Function to toggle password visibility
//   const handleClickShowPassword = () => {
//     setShowPassword(!showPassword);
//   };

//   return (
//     <div
//       style={{
//         backgroundImage: `url(${bgImage})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center 20%", // Moves the image slightly downward
//         minHeight: "100vh",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       <BasicLayout>
//         <Snackbar
//           open={snackbar.open}
//           autoHideDuration={6000}
//           onClose={handleSnackbarClose}
//           anchorOrigin={{ vertical: "top", horizontal: "center" }}
//         >
//           <Alert
//             onClose={handleSnackbarClose}
//             severity={snackbar.severity}
//             sx={{
//               width: "100%",
//               backgroundColor: snackbar.severity === "error" ? "#000" : undefined,
//               color: snackbar.severity === "error" ? "#fff" : undefined,
//             }}
//           >
//             {snackbar.message}
//           </Alert>
//         </Snackbar>

//         <Card>
//           {/* ✅ Toggle between SignIn and SignUp */}
//           {!showSignUp ? (
//             <>
//               <MDBox
//                 variant="gradient"
//                 bgColor="info"
//                 borderRadius="lg"
//                 coloredShadow="info"
//                 mx={2}
//                 mt={-3}
//                 p={2}
//                 mb={1}
//                 textAlign="center"
//               >
//                 <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
//                   Sign in
//                 </MDTypography>
//               </MDBox>

//               <MDBox pt={4} pb={3} px={3}>
//                 <MDBox component="form" role="form" onSubmit={handleSubmit}>
//                   <MDBox mb={2}>
//                     <MDInput
//                       type="text"
//                       label="Email ID"
//                       fullWidth
//                       value={identifier}
//                       onChange={(e) => setIdentifier(e.target.value)}
//                       error={!!errorIdentifier}
//                       helperText={errorIdentifier}
//                     />
//                   </MDBox>

//                   <MDBox mb={2}>
//                     <MDInput
//                       type={showPassword ? "text" : "password"}
//                       label="Password"
//                       fullWidth
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                       error={!!errorPassword}
//                       helperText={errorPassword}
//                       InputProps={{
//                         endAdornment: (
//                           <InputAdornment position="end">
//                             <IconButton
//                               aria-label="toggle password visibility"
//                               onClick={() => setShowPassword(!showPassword)}
//                               edge="end"
//                             >
//                               {showPassword ? <VisibilityOff /> : <Visibility />}
//                             </IconButton>
//                           </InputAdornment>
//                         ),
//                       }}
//                     />
//                   </MDBox>

//                   <MDBox mt={4} mb={1}>
//                     <MDButton variant="gradient" color="info" fullWidth type="submit" disabled={loading}>
//                       {loading ? "Signing in..." : "Sign in"}
//                     </MDButton>
//                   </MDBox>

//                   <MDBox mt={2} mb={2} textAlign="center">
//                     <MDTypography variant="button" color="text">
//                       Don&apos;t have an account?{" "}
//                       {/* <MDButton
//                         variant="text"
//                         color="info"
//                         onClick={() => setShowSignUp(true)}
//                         sx={{
//                           textTransform: "none",
//                           fontWeight: "medium",
//                           padding: 0,
//                           minWidth: "unset",
//                         }}
//                       >
//                         Sign up
//                       </MDButton> */}
//                       <MDButton
//                         variant="text"
//                         color="info"
//                         onClick={() => navigate("/authentication/sign-up-list")}
//                         sx={{
//                           textTransform: "none",
//                           fontWeight: "medium",
//                           padding: 0,
//                           minWidth: "unset",
//                         }}
//                       >
//                         Sign up
//                       </MDButton>
//                     </MDTypography>
//                   </MDBox>

//                 </MDBox>
//               </MDBox>
//             </>
//           ) : (
//             "" // ✅ Render signup form only when button is clicked
//           )}
//         </Card>
//       </BasicLayout>
//     </div>
//   );
// }

// export default Basic;


import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Snackbar, Alert, InputAdornment, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material"; // Import icons
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/banner.png";
import { Card } from "@mui/material";
import { usePublications } from "context/PublicationProvider";
import SignUp from "../secondSignUp";

function Basic() {
  const { fetchOffers } = usePublications();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [errorIdentifier, setErrorIdentifier] = useState("");
  const [errorPassword, setErrorPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });
  const [showPassword, setShowPassword] = useState(false); // State to manage password visibility
  const [showSignUp, setShowSignUp] = useState(false);

  const navigate = useNavigate();

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSnackbarClose = () => {
    setSnackbar({ open: false, message: "", severity: "info" });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    localStorage.setItem("popupShown", "false");
    setLoading(true);
    setErrorIdentifier("");
    setErrorPassword("");
    setSnackbar({ open: false, message: "", severity: "info" });

    if (!identifier.trim()) {
      setErrorIdentifier("Email ID cannot be empty.");
      setLoading(false);
      return;
    }
    if (!validateEmail(identifier)) {
      setErrorIdentifier("Please enter a valid email address.");
      setLoading(false);
      return;
    }
    if (!password.trim()) {
      setErrorPassword("Password cannot be empty.");
      setLoading(false);
      return;
    }

    try {
      const loginResponse = await axios.post("https://api.exampladmedia.com/auth/login", {
        identifier,
        password,
      });

      const accessToken = loginResponse.data.token;
      if (!accessToken) {
        throw new Error("Login failed, no access token received.");
      }

      localStorage.setItem("accessToken", accessToken);
      setSnackbar({ open: true, message: "Login successful!", severity: "success" });

      const authResponse = await axios.post("https://api.exampladmedia.com/auth/authenticate", {
        accessCode: accessToken,
      });

      const sessionToken = authResponse.data.sessionToken;
      const userRole = authResponse.data.userRole;
      const userId = authResponse.data.userId;
      const name = authResponse.data.name;

      if (!sessionToken) {
        throw new Error("Authentication failed.");
      }

      localStorage.setItem("sessionToken", sessionToken);
      localStorage.setItem("userRole", userRole);
      localStorage.setItem("ueserId", userId);
      localStorage.setItem("name", name);
      setSnackbar({ open: true, message: "Authentication successful.", severity: "success" });
      fetchOffers();
      navigate("/Tables");
    } catch (error) {
      let errorMessage = "Something went wrong!";
      if (error.response?.status === 401 || error.response?.status === 403) {
        errorMessage = "Invalid credentials.";
      }
      setSnackbar({ open: true, message: errorMessage, severity: "error" });
    } finally {
      setLoading(false);
    }
  };

  // Function to toggle password visibility
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center 20%", // Moves the image slightly downward
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <BasicLayout>
        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={snackbar.severity}
            sx={{
              width: "100%",
              backgroundColor: snackbar.severity === "error" ? "#000" : undefined,
              color: snackbar.severity === "error" ? "#fff" : undefined,
            }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>

        <Card>
          <MDBox
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
            mx={2}
            mt={-3}
            p={2}
            mb={1}
            textAlign="center"
          >
            <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
              Sign in
            </MDTypography>
          </MDBox>

          <MDBox pt={4} pb={3} px={3}>
            <MDBox component="form" role="form" onSubmit={handleSubmit}>
              <MDBox mb={2}>
                <MDInput
                  type="text"
                  label="Email ID"
                  fullWidth
                  value={identifier}
                  onChange={(e) => setIdentifier(e.target.value)}
                  error={!!errorIdentifier}
                  helperText={errorIdentifier}
                />
              </MDBox>

              <MDBox mb={2}>
                <MDInput
                  type={showPassword ? "text" : "password"}
                  label="Password"
                  fullWidth
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  error={!!errorPassword}
                  helperText={errorPassword}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </MDBox>

              <MDBox mt={4} mb={1}>
                <MDButton variant="gradient" color="info" fullWidth type="submit" disabled={loading}>
                  {loading ? "Signing in..." : "Sign in"}
                </MDButton>
              </MDBox>

              <MDBox mt={2} mb={2} textAlign="center">
                <MDTypography variant="button" color="text">
                  Don&apos;t have an account?{" "}
                  {/* <MDButton
                        variant="text"
                        color="info"
                        onClick={() => setShowSignUp(true)}
                        sx={{
                          textTransform: "none",
                          fontWeight: "medium",
                          padding: 0,
                          minWidth: "unset",
                        }}
                      >
                        Sign up
                      </MDButton> */}
                  <MDButton
                    variant="text"
                    color="info"
                    onClick={() => navigate("/authentication/sign-up-list")}
                    sx={{
                      textTransform: "none",
                      fontWeight: "medium",
                      padding: 0,
                      minWidth: "unset",
                    }}
                  >
                    Sign up
                  </MDButton>
                </MDTypography>
              </MDBox>

            </MDBox>
          </MDBox>

        </Card>
      </BasicLayout>
    </div>
  );
}

export default Basic;